<template>
    <div>
        <p class="darkest">{{notification.metadata.bookingNote}}</p>
        <button v-if="showInvoiceBtn" class="btn tertiary narrow my-1" @click="viewBooking">View booking</button>
    </div>
</template>

<script>
export default {
    props:{
        notification: {
            type: Object,
        }
    },
    computed: {
        showInvoiceBtn: function () {
            if(this.notification.metadata && this.notification.metadata.bookingId){
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        viewBooking: function () {
            window.open('/reservations/view/'+this.notification.metadata.bookingId, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
    p{
        word-break: break-word;
        text-overflow: ellipsis;
        width: 90%;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// bodyBookingWithNotes.vue?4556fe01